import { ElasticCobaltSortKeyEnumType, ElasticCobaltSortTypeEnumType } from '@mark43/cad-api';
import { useEffect, useState } from 'react';
import { Option } from '../forms/option';

export type ElasticSortKeyOption = Option<ElasticCobaltSortKeyEnumType>;
export type ElasticSortTypeOption = Option<ElasticCobaltSortTypeEnumType>;

export type SortContextType = {
    sortByValue: ElasticSortKeyOption;
    setSortByValue: (value: ElasticSortKeyOption) => void;
    directionValue: ElasticSortTypeOption;
    setDirectionValue: (value: ElasticSortTypeOption) => void;
    sortByOptions: ElasticSortKeyOption[];
    directionOptions: ElasticSortTypeOption[];
};

export function useSearchSort(
    sortByOptions: ElasticSortKeyOption[],
    directionOptionsBySortKey: Partial<
        Record<ElasticCobaltSortKeyEnumType, ElasticSortTypeOption[]>
    >
): SortContextType {
    const [sortByValue, setSortByValue] = useState<ElasticSortKeyOption>(sortByOptions[0]);
    const [directionOptions, setDirectionOptions] = useState<ElasticSortTypeOption[]>(
        directionOptionsBySortKey[sortByValue.value]!
    );
    const [directionValue, setDirectionValue] = useState<ElasticSortTypeOption>(
        directionOptions[0]
    );
    useEffect(() => {
        const newDirectionOptions = directionOptionsBySortKey[sortByValue.value]!;
        setDirectionOptions(newDirectionOptions);
        setDirectionValue(newDirectionOptions[0]);
    }, [directionOptionsBySortKey, sortByValue]);
    return {
        sortByValue,
        setSortByValue,
        directionValue,
        setDirectionValue,
        sortByOptions,
        directionOptions,
    };
}
